require('./dist/select.js');
module.exports = 'ui.select';



//////////////////
// WEBPACK FOOTER
// ../~/ui-select/index.js
// module id = 81
// module chunks = 1